import React from "react";
import { cn } from "src/lib/utils";

interface MenuTitleProps {
  title: string;
  isOpen: boolean;
  className?: string;
}

const MenuTitle: React.FC<MenuTitleProps> = ({ title, isOpen, className }) => {
  if (!isOpen) {
    return null;
  }

  return <div className={cn("px-0 py-1 text-[10px] font-medium tracking-[-.00125em] text-muted-foreground uppercase", className)}>{title}</div>;
};

export default MenuTitle;
